import { filterOptions } from '@/utils/query-base'
import { formatSapDate } from '@/mixins/index'
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export default {
  'partner_original': {
    title: '原始客户编号',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '原始客户编号'
    }
  },
  'partner_oname': {
    title: '原始客户名称',
    type: 'input',
    equation: cusname,
    width: 250
  },
  'partner_before': {
    title: '前一次变更客户编号',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '前一次变更客户编号'
    },
    width: 200
  },
  'partner_bname': {
    title: '前一次变更客户名称',
    type: 'input',
    equation: cusname,
    width: 250
  },
  'partner': {
    title: '客户编号',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '客户编号'
    }
  },
  'partner_name': {
    title: '客户名称',
    type: 'input',
    equation: cusname,
    width: 250
  },
  'partner_new': {
    title: '最新客户编号',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '最新客户编号'
    }
  },
  'partner_nname': {
    title: '最新客户名称',
    type: 'input',
    equation: cusname,
    width: 250
  },
  'c_datum1': {
    title: '原始客户创建日期',
    type: 'date',
    equation: all,
    width: 200,
    formatter: ({ cellValue }) => formatSapDate(cellValue)
  },
  'c_paertner1': {
    title: '原始客户',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '原始客户'
    }
  },
  'c_paertner1_d': {
    title: '原始客户名称',
    type: 'input',
    equation: cusname,
    width: 250
  },
  'c_datum2': {
    title: '第1次变更日期',
    type: 'date',
    equation: all,
    formatter: ({ cellValue }) => formatSapDate(cellValue)
  },
  'c_paertner2': {
    title: '第1次变更客户',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '第1次变更客户'
    }
  },
  'c_paertner2_d': {
    title: '第1次变更客户名称',
    type: 'input',
    equation: cusname,
    width: 250
  },
  'c_datum3': {
    title: '第2次变更日期',
    type: 'date',
    equation: all,
    formatter: ({ cellValue }) => formatSapDate(cellValue)
  },
  'c_paertner3': {
    title: '第2次变更客户',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '第2次变更客户'
    }
  },
  'c_paertner3_d': {
    title: '第2次变更客户名称',
    type: 'input',
    equation: cusname,
    width: 250
  },
  'c_datum4': {
    title: '第3次变更日期',
    type: 'date',
    equation: all,
    formatter: ({ cellValue }) => formatSapDate(cellValue)
  },
  'c_paertner4': {
    title: '第3次变更客户',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '第3次变更客户'
    }
  },
  'c_paertner4_d': {
    title: '第3次变更客户名称',
    type: 'input',
    equation: cusname,
    width: 250
  },
  'c_datum5': {
    title: '第4次变更日期',
    type: 'date',
    equation: all,
    formatter: ({ cellValue }) => formatSapDate(cellValue)
  },
  'c_paertner5': {
    title: '第4次变更客户',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '第4次变更客户'
    }
  },
  'c_paertner5_d': {
    title: '第4次变更客户名称',
    type: 'input',
    equation: cusname,
    width: 250
  },
  'c_datum6': {
    title: '第5次变更日期',
    type: 'date',
    equation: all,
    formatter: ({ cellValue }) => formatSapDate(cellValue)
  },
  'c_paertner6': {
    title: '第5次变更客户',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '第5次变更客户'
    }
  },
  'c_paertner6_d': {
    title: '第5次变更客户名称',
    type: 'input',
    equation: cusname,
    width: 250
  },
  'c_datum7': {
    title: '第6次变更日期',
    type: 'date',
    equation: all,
    formatter: ({ cellValue }) => formatSapDate(cellValue)
  },
  'c_paertner7': {
    title: '第6次变更客户',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '第6次变更客户'
    }
  },
  'c_paertner7_d': {
    title: '第6次变更客户名称',
    type: 'input',
    equation: cusname,
    width: 250
  },
  'c_datum8': {
    title: '第7次变更日期',
    type: 'date',
    equation: all,
    formatter: ({ cellValue }) => formatSapDate(cellValue)
  },
  'c_paertner8': {
    title: '第7次变更客户',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '第7次变更客户'
    }
  },
  'c_paertner8_d': {
    title: '第7次变更客户名称',
    type: 'input',
    equation: cusname,
    width: 250
  },
  'c_datum9': {
    title: '第8次变更日期',
    type: 'date',
    equation: all,
    formatter: ({ cellValue }) => formatSapDate(cellValue)
  },
  'c_paertner9': {
    title: '第8次变更客户',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '第8次变更客户'
    }
  },
  'c_paertner9_d': {
    title: '第8次变更客户名称',
    type: 'input',
    equation: cusname,
    width: 250
  },
  'c_datum10': {
    title: '第9次变更日期',
    type: 'date',
    equation: all,
    formatter: ({ cellValue }) => formatSapDate(cellValue)
  },
  'c_paertner10': {
    title: '第9次变更客户',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '第9次变更客户'
    }
  },
  'c_paertner10_d': {
    title: '第9次变更客户名称',
    type: 'input',
    equation: cusname,
    width: 250
  },
  'c_datum11': {
    title: '第10次变更日期',
    type: 'date',
    equation: all,
    formatter: ({ cellValue }) => formatSapDate(cellValue)
  },
  'c_paertner11': {
    title: '第10次变更客户',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '第10次变更客户'
    }
  },
  'c_paertner11_d': {
    title: '第10次变更客户名称',
    type: 'input',
    equation: cusname,
    width: 250
  },
  'c_datum12': {
    title: '第11次变更日期',
    type: 'date',
    equation: all,
    formatter: ({ cellValue }) => formatSapDate(cellValue)
  },
  'c_paertner12': {
    title: '第11次变更客户',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '第11次变更客户'
    }
  },
  'c_paertner12_d': {
    title: '第11次变更客户名称',
    type: 'input',
    equation: cusname,
    width: 250
  },
  'c_datum13': {
    title: '第12次变更日期',
    type: 'date',
    equation: all,
    formatter: ({ cellValue }) => formatSapDate(cellValue)
  },
  'c_paertner13': {
    title: '第12次变更客户',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '第12次变更客户'
    }
  },
  'c_paertner13_d': {
    title: '第12次变更客户名称',
    type: 'input',
    equation: cusname,
    width: 250
  },
  'c_datum14': {
    title: '第13次变更日期',
    type: 'date',
    equation: all,
    formatter: ({ cellValue }) => formatSapDate(cellValue)
  },
  'c_paertner14': {
    title: '第13次变更客户',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '第13次变更客户'
    }
  },
  'c_paertner14_d': {
    title: '第13次变更客户名称',
    type: 'input',
    equation: cusname,
    width: 250
  },
  'c_datum15': {
    title: '第14次变更日期',
    type: 'date',
    equation: all,
    formatter: ({ cellValue }) => formatSapDate(cellValue)
  },
  'c_paertner15': {
    title: '第14次变更客户',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '第14次变更客户'
    }
  },
  'c_paertner15_d': {
    title: '第14次变更客户名称',
    type: 'input',
    equation: cusname,
    width: 250
  },
  'c_datum16': {
    title: '第15次变更日期',
    type: 'date',
    equation: all,
    formatter: ({ cellValue }) => formatSapDate(cellValue)
  },
  'c_paertner16': {
    title: '第15次变更客户',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '第15次变更客户'
    }
  },
  'c_paertner16_d': {
    title: '第15次变更客户名称',
    type: 'input',
    equation: cusname,
    width: 250
  },
  'c_datum17': {
    title: '第16次变更日期',
    type: 'date',
    equation: all,
    formatter: ({ cellValue }) => formatSapDate(cellValue)
  },
  'c_paertner17': {
    title: '第16次变更客户',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '第16次变更客户'
    }
  },
  'c_paertner17_d': {
    title: '第16次变更客户名称',
    type: 'input',
    equation: cusname,
    width: 250
  },
  'c_datum18': {
    title: '第17次变更日期',
    type: 'date',
    equation: all,
    formatter: ({ cellValue }) => formatSapDate(cellValue)
  },
  'c_paertner18': {
    title: '第17次变更客户',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '第17次变更客户'
    }
  },
  'c_paertner18_d': {
    title: '第17次变更客户名称',
    type: 'input',
    equation: cusname,
    width: 250
  },
  'c_datum19': {
    title: '第18次变更日期',
    type: 'date',
    equation: all,
    formatter: ({ cellValue }) => formatSapDate(cellValue)
  },
  'c_paertner19': {
    title: '第18次变更客户',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '第18次变更客户'
    }
  },
  'c_paertner19_d': {
    title: '第18次变更客户名称',
    type: 'input',
    equation: cusname,
    width: 250
  },
  'c_datum20': {
    title: '第19次变更日期',
    type: 'date',
    equation: all,
    formatter: ({ cellValue }) => formatSapDate(cellValue)
  },
  'c_paertner20': {
    title: '第19次变更客户',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '第19次变更客户'
    }
  },
  'c_paertner20_d': {
    title: '第19次变更客户名称',
    type: 'input',
    equation: cusname,
    width: 250
  }
}



// WEBPACK FOOTER //
// ./src/views/client-manage/config/customerChangeHistory.js